import { api } from "@/lib/api";

export async function uploadDocument(file, docType, progress = () => {}) {
  progress({ phase: "Preparazione", percent: 0 });
  const contentType = file.type || (/\.pdf$/i.test(file.name) ? "application/pdf" : "");
  const { data } = await api.post("/uploads/document/init", { filename: file.name, size: file.size, content_type: contentType, doc_type: docType });
  try {
    let index = 0;
    for (let offset = 0; offset < file.size; offset += data.chunk_size) {
      const chunk = file.slice(offset, offset + data.chunk_size);
      await api.put(`/uploads/document/${data.upload_id}/chunks/${index++}`, chunk, { headers: { "Content-Type": "application/octet-stream" } });
      progress({ phase: "Caricamento", percent: Math.min(90, Math.round((offset + chunk.size) / file.size * 90)) });
    }
    progress({ phase: "Salvataggio", percent: 95 });
    const result = await api.post(`/uploads/document/${data.upload_id}/complete`);
    progress({ phase: "Documento salvato", percent: 100 });
    return result.data;
  } catch (error) {
    progress({ phase: "Caricamento interrotto: puoi riprovare", percent: 0 });
    try { await api.delete(`/uploads/document/${data.upload_id}`); } catch {}
    throw error;
  }
}
